module.exports = __webpack_public_path__ + "static/media/angular.991097fe.svg";